<div class="step-container" >

    <div class="d-flex justify-content-between mb-4">
        <div>
          <div class="vendortitle">Applicant Notes</div>
          <div class="subtitle">List of Applicant Notes</div>
        </div>
        <div *ngIf="gridData?.length && gridData.length > 0">

          <button class="btn btn-primary" (click)="exportToCSV()">
            Export to CSV
          </button>
        </div>
      </div>
      
      <ng-template #noData>
        <div class="d-flex flex-column justify-content-center align-items-center p-4 bg-light border rounded shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" 
               width="120" height="120" 
               viewBox="0 0 24 24" 
               fill="none" stroke="#2563eb" 
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
               style="opacity: 0.9;" class="mb-3">
            <rect x="3" y="4" width="18" height="16" rx="2" ry="2"></rect>
            <line x1="8" y1="10" x2="16" y2="10"></line>
            <line x1="8" y1="14" x2="14" y2="14"></line>
          </svg>
      
          <h5 class="text-primary">No Applications Found</h5>
          <p class="text-secondary small">Try adjusting filters or check back later.</p>
        </div>
      </ng-template>
      
      
      <!-- {{gridData | json}} -->
      <div class="table-container scrollbar"*ngIf="gridData?.length && gridData.length > 0; else noData">
        <ag-grid-angular class="ag-theme-quartz auto-height commontable"
          [rowData]="gridData"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [suppressRowClickSelection]="false"
          [pagination]="false"
          [paginationPageSize]="paginationPageSize"
          [class]="themeClass"
          (gridReady)="onGridReady($event)"
          [gridOptions]="gridOptions">
        </ag-grid-angular>
           
      </div>
            
</div>